var React = require('react');

function IconCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.50004 13.4777L4.02226 9.99996L2.84448 11.1777L7.50004 15.8333L17.5 5.8333L16.3223 4.65552L7.50004 13.4777Z","fill":"#000000"}));
}

IconCheck.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IconCheck;

IconCheck.default = IconCheck;
